export const DIAMOND_SPECIAL_CHAR = '__diamond__';
export const DIAMOND_WITH_SPARKS_SPECIAL_CHAR = '__diamond_with_sparks__';

export const specialChars: {
  readonly diamond: typeof DIAMOND_SPECIAL_CHAR;
  readonly diamondWithSparks: typeof DIAMOND_WITH_SPARKS_SPECIAL_CHAR;
} = {
  diamond: DIAMOND_SPECIAL_CHAR,
  diamondWithSparks: DIAMOND_WITH_SPARKS_SPECIAL_CHAR,
};
